import { useTranslation } from 'react-i18next';

export type ProductsHeroProps = {
  className?: string;
};

export const ProductsHero = ({ className = '' }: ProductsHeroProps) => {
  const { t } = useTranslation();

  return (
    <section
      className={`${className} h-auto lg:h-[520px] max-w-6xl m-auto px-3 py-2 lg:px-8 lg:py-10 text-center lg:text-left relative`}
    >
      <div className="z-40 relative h-full">
        <h1 className="md__payments__title--h1">{t('ProductsHero.title')}</h1>
        <p className="text-xl w-full lg:w-2/5 text-md-black font-thin">
          {t('ProductsHero.description')}
        </p>
      </div>
      <div className="md__products__hero__picture absolute hidden lg:block bottom-0 left-0 right-0 top-0" />
    </section>
  );
};
